<template>
  <v-app light>
    <div class="layout fill-height wrapper column align-center justify-items-center">
      <div style="max-height: 500px" class="card layout column">
        <div class="logo mb-2">
          <img src="@/assets/logo.svg" alt="iisy-logo" />
        </div>
        <div class="header mb-5">
          Enter your new password
        </div>
        <div class="form">
          <v-form key="1" v-model="valid">
            <v-text-field
              v-model="form.password"
              :rules="rules.password"
              type="password"
              autofocus
              autocomplete="password"
              aria-autocomplete="password"
              color="primary"
              label="Password"
              outlined
            />
            <v-text-field
              v-model="form.passwordConfirmation"
              :rules="rules.passwordConfirmation"
              type="password"
              autocomplete="passwordConfirmation"
              aria-autocomplete="passwordConfirmation"
              color="primary"
              label="Password Confirmation"
              outlined
            />
          </v-form>
        </div>
        <div class="actions layout justify-end align-center">
          <v-btn color="primary" text @click="reset">
            Reset
          </v-btn>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import { resetPassword } from '../../services/graph/auth.graph';

export default {
  name: 'ResetPassword',
  data() {
    return {
      valid: false,
      form: {
        token: '',
        password: '',
        passwordConfirmation: ''
      },
      rules: {
        email: [v => !!v || 'E-mail is required.', v => /.+@.+/.test(v) || 'E-mail must be valid.'],
        password: [
          v => !!v || 'Password is required.',
          v => v.length >= 6 || 'Password needs to be longer than 6 characters.'
        ],
        passwordConfirmation: [
          v => !!v || 'Password is required.',
          v => (!!v && v.length >= 6) || 'Password needs to be longer than 6 characters.',
          v => v === this.form.passwordConfirmation || 'Passwords do not match.'
        ]
      }
    };
  },
  mounted() {
    if (!this.$route.query.token) {
      this.$router.go(-1);
    } else {
      this.form.token = this.$route.query.token;
    }
  },
  methods: {
    reset() {
      resetPassword({ token: this.form.token, newPassword: this.form.password }).then(() => {
        alert('Password has been resetted. You will be redirected to login in 3 seconds...');
        const self = this;
        setTimeout(() => {
          self.$router.push({ name: 'login' });
        }, 3000);
      });
    }
  }
};
</script>
<style scoped>
.wrapper {
  justify-content: center;
  font-family: 'IBMPlex', sans-serif;
  background-color: #f5f5f5;
}
.card {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  width: 450px;
  padding: 30px;
  height: 500px;
  background-color: white;
  max-height: 90%;
  border: 1px solid #dadce0;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  text-align: center;
  align-self: center;
  justify-self: center;
}
.card .header {
  font-family: 'IBMPlex', 'Roboto', 'Noto Sans Myanmar UI', arial, sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 1.3333;
}
.card .form {
  margin-top: 20px;
}
.card .left-align {
  text-align: left;
  margin: 10px;
}
</style>
